





















































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class BridgeStatsFilter extends Vue {
  @Prop({type: Boolean, required: true}) isDepositSelected!: boolean
  @Prop({type: Boolean, required: true}) isWalletHistoryVisible!: boolean

  handleSelectFilter(filter: boolean) {
    this.$emit('filter', filter)
  }
}
